import { StyledInput } from "components/forms/inputs/text.styles";
import Icon from "components/icon";
import styled from "@emotion/styled";
import { Colors } from "theme/colors";
import { css } from "@emotion/react";

export const StyledWrapper = styled.div`
  position: relative;
  width: 17.65rem;
`;

export const StyledIcon = styled(Icon)`
  position: absolute;
  top: 0.7rem;
  left: 0.825rem;
  color: ${Colors.DARK_GRAY};
`;

interface InputProps {
  $focus: boolean;
}

export const StyledSearch = styled(StyledInput)<InputProps>`
  padding-left: 2.5rem;

  ${(props) =>
    props.$focus &&
    css`
      padding-left: calc(2.5rem - 0.118rem);

      & ~ ${StyledIcon} {
        color: ${Colors.MID_BLUE};
      }
    `}
`;
